import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from "react";

const AttachmentValidationContext = createContext({
  warnings: [],
  reportWarnings: () => {},
});

export const useAttachmentValidation = () =>
  useContext(AttachmentValidationContext);

export const AttachmentValidationProvider = ({ children }) => {
  const [warningsMap, setWarningsMap] = useState({});

  const reportWarnings = useCallback((sectionKey, sectionWarnings) => {
    setWarningsMap((prev) => {
      const prevKeys = (prev[sectionKey] || []).map((w) => w.message).join("|");
      const newKeys = sectionWarnings.map((w) => w.message).join("|");
      if (prevKeys === newKeys) return prev;
      return { ...prev, [sectionKey]: sectionWarnings };
    });
  }, []);

  const warnings = useMemo(() => Object.values(warningsMap).flat(), [warningsMap]);

  const value = useMemo(() => ({ warnings, reportWarnings }), [warnings, reportWarnings]);

  return (
    <AttachmentValidationContext.Provider value={value}>
      {children}
    </AttachmentValidationContext.Provider>
  );
};
